module.exports = __webpack_public_path__ + "asset/image-no-data-07c7e899bc84604a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/calendar/component/calendar-dashboard/image/no-data.svg
// module id = vx4v
// module chunks = 0